import { useEffect, useState } from "react";

import { Box } from "@mui/material";

import useSurvey from "../../hooks/useSurvey";

const QuestionSectionStatus = ({ section, questions, answers, location }) => {
  const { getQuestionSectionStatus } = useSurvey();

  const [questionSectionStatus, setQuestionSectionStatus] = useState({
    colorCode: "#ccc",
  });

  useEffect(() => {
    const checkStatus = async () => {
      const status = await getQuestionSectionStatus(
        section,
        questions,
        answers,
        location,
      );

      setQuestionSectionStatus(status);
    };

    checkStatus();
  }, [section, questions, answers, location]);

  return (
    <Box
      sx={{
        width: "5px",
        height: "5px",
        backgroundColor: questionSectionStatus.colorCode,
        margin: "1px",
        borderRadius: "50%",
      }}
    ></Box>
  );
};

export default QuestionSectionStatus;
